import EmObject from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { isNone } from '@ember/utils';
import { task } from 'ember-concurrency';
import ApiService from 'cio/services/api';

type ActionResponse = {
  id: string;
  eval_stage: string;
  eval_progress: number;
  subject_count: number;
  subject_count_limited: boolean;
};

type Subjects = EmObject & {
  id: string;
  isProcessing?: boolean;
  isSynchronizing?: boolean;
  progress?: number;
  count?: number;
  subjectCountLimited?: boolean;
};

export const SUBJECT_COUNT_LIMIT = 1000000;

export default class ActionSubjectsService extends Service {
  @service api!: ApiService;

  store: Subjects[] = [];

  fetch = task({ drop: true }, async (campaignId: string) => {
    let path = `campaigns/${campaignId}/action_status`;
    let response = await this.api.request(path, { ignoreErrors: true });

    response.actions.forEach((action: ActionResponse) => {
      let subjects = this.find(action.id);

      subjects.setProperties({
        isProcessing: action.eval_stage === 'Processing',
        isSynchronizing: action.eval_stage === 'Synchronizing',
        progress: action.eval_progress,
        count: action.subject_count,
        subjectCountLimited: action.subject_count_limited,
      });
    });
  });

  find(id: string) {
    let subjects: Subjects | undefined = this.store.findBy('id', `${id}`);

    if (isNone(subjects)) {
      subjects = EmObject.create({ id: `${id}` });
      this.store.pushObject(subjects);
    }

    return subjects;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'action-subjects': ActionSubjectsService;
  }
}
